// Las tools que Claude puede usar. Cada una es un archivo con
// { definition, run(input, ctx) } (ver runAssistant.js); para agregar una
// capacidad se escribe el archivo y se suma aquí.
import searchParts from "./searchParts.js";
import searchPartsByText from "./searchPartsByText.js";
import findVehicle from "./findVehicle.js";
import checkStock from "./checkStock.js";
import findCustomer from "./findCustomer.js";
import createQuote from "./createQuote.js";
import updateQuote from "./updateQuote.js";
import quoteShipping from "./quoteShipping.js";

export default [
  searchParts,
  searchPartsByText,
  findVehicle,
  checkStock,
  findCustomer,
  createQuote,
  updateQuote,
  quoteShipping
];
